import axiosClient from "api/axiosInstance";
import { IdcTransaction } from "api/models/IdcTransaction";

export const getIdcTransactions = async (
  from: string,
  to: string,
  parkIds: number[],
): Promise<{ data: IdcTransaction[] }> => {
  const client = axiosClient();
  const queryParams = new URLSearchParams({ from, to });
  if (parkIds.length > 0) {
    queryParams.set("parkIds", parkIds.join(","));
  }
  const response = await client.get(`/idc-transactions?${queryParams}`);
  return response.data;
};
